/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Artcraft_AInputs */

const en_wc_faq_artcraft_a = /** @type {(inputs: Wc_Faq_Artcraft_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft is ArtCraft's free, open-source word processor. ArtCraft develops the app; this site independently hosts its browser build and provides download guides and tutorials.`)
};

/**
* | output |
* | --- |
* | "WordCraft is ArtCraft's free, open-source word processor. ArtCraft develops the app; this site independently hosts its browser build and provides download gu..." |
*
* @param {Wc_Faq_Artcraft_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_artcraft_a = /** @type {((inputs?: Wc_Faq_Artcraft_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Artcraft_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_artcraft_a(inputs)
});
export { wc_faq_artcraft_a as "wc.faq.artcraft.a" }